// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fN","seoBlockContent_visible":"c-a_fO"};